/**
 * @fileoverview 言語選択用ドロップダウンリストのコンポーネント
 */

import { useTranslation } from "react-i18next";
import "./LanguageSelector.css";
import "flag-icons/css/flag-icons.min.css";

const LanguageSelector: React.FC = () => {
  const { i18n } = useTranslation();
  const { t } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  const getFlagClass = (language: string) => {
    switch (language) {
      case "en":
        return "fi fi-us";
      case "ja":
        return "fi fi-jp";
      case "ko":
        return "fi fi-kr";
      default:
        return "";
    }
  };

  return (
    <div className="language-selector-container">
      <label>
        {t("言語")}:
        <select
          className="language-selector"
          onChange={(e) => changeLanguage(e.target.value)}
          value={i18n.language}
        >
          <option value="en">English</option>
          <option value="ja">日本語</option>
          <option value="ko">한국어</option>
        </select>
      </label>
      <span className={`${getFlagClass(i18n.language)}`}></span>
    </div>
  );
};

export default LanguageSelector;
